// @vendors
import { useRef, useMemo } from 'react';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import { Button, Typography } from '@mui/material';
import { theme } from '../../assets/theme';

const Style = () => ({
  dialog:{
    '& .MuiDialog-paper': { 
      width: '80%', maxHeight: 435,
      borderRadius: '9px'
    }
  },
  body:{
    padding: '40px'
  },
  title:{
    fontSize: "1.2rem",
    display: 'flex',
    fontWeight: '600',
    color: theme.palette.primary.black,
    margin: '0px',
    textAlign: 'center',
    lineHeight: '1.3rem',
  },
  titlePayroll:{
    fontSize: "1rem",
    display: 'flex',
    fontWeight: 700,
    //color: '#252A31',
    fontFamily: 'Inter',
    margin: '0px',
    textAlign: 'center',
    color: theme.palette.primary.black,
  },
  containerButtons:{
    width: '100%',
    display: 'flex',
    gap: '15px',
    justifyContent: 'end',
    marginTop: '30px'
  },
  button: {
    color: theme.palette.primary.white,  
    backgroundColor: theme.palette.primary.black,
    ':hover': { backgroundColor: '#BAC7D5', boxShadow: 1 },
  },
  styleCommontButtom: {
    fontSize: '0.8rem',
    fontWeight: 500,
    padding: '10px 25px',
    border: 'none',
    borderRadius: 1
  },
  buttonAccept: {
      color: theme.palette.primary.white,
      backgroundColor: theme.payroll.greenMain,
      '&:hover': {
          backgroundColor: theme.payroll.greenMain,
          boxShadow: 1
      },
  },
  buttonClose: {
      color: theme.palette.primary.black, 
      backgroundColor: '#E8EDF1',
      '&:hover': {
          backgroundColor: '#BAC7D5',
          boxShadow: 1
      },
  },
})

function ConfirmationDialog(props) {
  const { onClose, open, view, title} = props;
  const radioGroupRef = useRef(null);
  const style = useMemo(() => Style(), [])

  const handleEntering = () => {
    if (radioGroupRef.current != null) {
      radioGroupRef.current.focus();
    }
  };

  const handleCancel = (value) => {
    onClose(value);
  };

  return (
    <Dialog
      sx={style.dialog}
      maxWidth="xs"
      TransitionProps={{ onEntering: handleEntering }}
      open={open}
    >
      <DialogContent sx={style.body}>
        <Typography sx={view === 'payroll' ? style.titlePayroll : style.title}>
          {title ? title : 'Are you sure you would like to make this change?'}
        </Typography>
        <div style={style.containerButtons}>
            <Button
                autoFocus
                onClick={() => handleCancel(view === 'payroll' ? false : 'no')}
                sx={{...style.buttonClose, ...style.styleCommontButtom}}
                variant="contained"
            >
                Cancel
            </Button>
            <Button
                sx={view === 'payroll' ? {...style.buttonAccept, ...style.styleCommontButtom} : {...style.button, ...style.styleCommontButtom}}
                onClick={() => handleCancel(view === 'payroll' ? true : 'yes')}
                variant="contained"
            >
                {view === 'payroll' ? 'Allow' : 'Accept'}
            </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
export default ConfirmationDialog